import React, { useState } from 'react';
import { toast } from 'react-toastify';

import Button from '../ui/Button';
import Modal from '../ui/Modal';
import TeamCard from '../Incident/TeamCard';
import TeamsService from '../../services/TeamsService';

import CreateTeamDialog from '../Dashboard/CreateTeamModal';
import { processTeamData } from '../../utils/utils';

const TeamDialog = ({ announcementId, status }) => {
    const [open, setOpen] = useState(false);
    const [teams, setTeams] = useState([]);

    const handleClickOpen = async () => {
        const response = await TeamsService.findAll()

        if (response.data.error) {
            toast.error("Something went wrong!")
            return;
        }
        setTeams(() => processTeamData(response.data))
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    // Assigning teams to a closed/rejected incident isn't a valid action —
    // this dialog is for standing up a response, not something a finished
    // event needs.
    if (status === 'Closed' || status === 'Rejected') return null;

    return (
        <div>
            <Button variant="secondary" onClick={handleClickOpen}>
                Activate
            </Button>

            <Modal
                open={open}
                onClose={handleClose}
                title={`${teams.length > 0 ? teams.length : "No"} Teams`}
                size="md"
                footer={<Button variant="primary" onClick={handleClose}>Done</Button>}
            >
                <CreateTeamDialog handleClickOpenTeamModal={handleClickOpen} />

                <TeamCard assigned={false} teams={teams} setTeams={setTeams} announcementId={announcementId} />
            </Modal>
        </div>
    );
}

export default TeamDialog;
